module.exports = __webpack_public_path__ + "summernote.549304631a5f1ab69498.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/vendor/summernote/summernote.ttf?ad8d7e2d177d2473aecd9b35d16211fb
// module id = ../../../../../src/vendor/summernote/summernote.ttf?ad8d7e2d177d2473aecd9b35d16211fb
// module chunks = 5